var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { SPACING } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';
export var getMarkdownComponents = function (contentSize, navigate) { return ({
    table: function (_a) {
        var props = __rest(_a, []);
        return _jsx("table", __assign({ style: tableStyle }, props));
    },
    th: function (_a) {
        var props = __rest(_a, []);
        return _jsx("th", __assign({ style: tableHeaderStyle }, props));
    },
    td: function (_a) {
        var props = __rest(_a, []);
        return _jsx("td", __assign({ style: tableCellStyle }, props));
    },
    a: function (_a) {
        var href = _a.href, props = __rest(_a, ["href"]);
        var isInternalLink = href === null || href === void 0 ? void 0 : href.startsWith('/');
        if (isInternalLink && navigate) {
            return (_jsx("a", __assign({ style: linkStyle, href: href, onClick: function (e) {
                    e.preventDefault();
                    if (href && navigate) {
                        navigate(href);
                    }
                } }, props)));
        }
        return _jsx("a", __assign({ style: linkStyle, href: href, target: "_blank", rel: "noopener noreferrer" }, props));
    },
    ul: function (_a) {
        var props = __rest(_a, []);
        return _jsx("ul", __assign({ style: listStyle(contentSize) }, props));
    },
    ol: function (_a) {
        var props = __rest(_a, []);
        return _jsx("ol", __assign({ style: listStyle(contentSize) }, props));
    },
    p: function (_a) {
        var props = __rest(_a, []);
        return _jsx("p", __assign({ style: paragraphStyle(contentSize) }, props));
    },
    li: function (_a) {
        var props = __rest(_a, []);
        return _jsx("li", __assign({ style: listItemStyle(contentSize) }, props));
    },
}); };
var tableStyle = {
    borderCollapse: 'separate',
    borderSpacing: 0,
    width: '100%',
    borderTop: "2px solid ".concat(COLOR_TOKENS['Colors/Text/text-primary']),
    borderBottom: "2px solid ".concat(COLOR_TOKENS['Colors/Text/text-primary']),
    marginTop: "".concat(SPACING['spacing-2xl']),
};
var tableHeaderStyle = {
    border: 'none',
    padding: "".concat(SPACING['spacing-xs'], " ").concat(SPACING['spacing-sm']),
    color: COLOR_TOKENS['Colors/Text/text-primary'],
    borderBottom: "2px solid ".concat(COLOR_TOKENS['Colors/Text/text-primary']),
    textAlign: 'left',
};
var tableCellStyle = {
    border: 'none',
    padding: "".concat(SPACING['spacing-xs'], " ").concat(SPACING['spacing-sm']),
    whiteSpace: 'nowrap',
    width: 'fit-content',
};
var linkStyle = {
    color: COLOR_TOKENS['Colors/Foreground/fg-brand-primary'],
    fontWeight: 'bold',
};
var fontSizeForSize = function (contentSize) {
    return contentSize === 'XLARGE' ? '20px' : contentSize === 'LARGE' ? '16px' : '14px';
};
var lineHeightForSize = function (contentSize) {
    return contentSize === 'XLARGE' ? '30px' : undefined;
};
var paragraphStyle = function (contentSize) { return ({
    fontSize: fontSizeForSize(contentSize),
    lineHeight: lineHeightForSize(contentSize),
    letterSpacing: 0,
}); };
var listItemStyle = function (contentSize) { return ({
    fontSize: fontSizeForSize(contentSize),
    lineHeight: lineHeightForSize(contentSize),
    marginBottom: '0.5em',
    letterSpacing: 0,
}); };
var listStyle = function (contentSize) { return ({
    paddingLeft: contentSize === 'SMALL' ? '1.5rem' : undefined,
    marginBottom: '0.5em',
    letterSpacing: 0,
}); };
